module.exports = __webpack_public_path__ + "img/C++.6a381fc0.png";